/* eslint-disable react/jsx-max-props-per-line */
import { Link, useLocation } from 'react-router-dom';
import { cn } from 'src/lib/utils';

const links = [
  { to: '/billing/pipeline/imports', label: 'Imports' },
  { to: '/billing/pipeline/review', label: 'Review queue' },
] as const;

export function PipelineSubNav() {
  const { pathname } = useLocation();

  return (
    <nav className="flex flex-wrap items-center gap-2 border-b border-gray-200 pb-3 mb-4" aria-label="Billing pipeline">
      {links.map(({ to, label }) => (
        <Link
          key={to}
          to={to}
          className={cn(
            'rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
            pathname === to || pathname.startsWith(`${to}/`)
              ? 'bg-gray-900 text-white'
              : 'text-gray-600 hover:bg-gray-100'
          )}
        >
          {label}
        </Link>
      ))}
    </nav>
  );
}
